import { Navigate, useLocation } from 'react-router-dom';
import { Box, Center, Spinner, Stack, Text } from '@chakra-ui/react';
import React from 'react'; // Ensure React is in scope
import { AUTH_PROVIDERS, useAuthProvider } from './AuthProviderSwitch';
import { OrganizationSwitcher } from '../ClerkAuthentication/clerkReact';
import { hasClientAccess, hasInternalAccess } from './roleAccess';

const ProtectedRoute = ({ children }) => {
  // All hooks called at the top level
  const { isAuthenticated, isLoading, provider, orgId, orgRole, has } = useAuthProvider();
  const location = useLocation();

  // Original auth flow
  if (isLoading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (provider === AUTH_PROVIDERS.CLERK && !orgId) {
    return (
      <Center h="100vh" px={6}>
        <Box
          bg="white"
          borderWidth="1px"
          borderRadius="lg"
          p={6}
          maxW="480px"
          w="full"
          boxShadow="sm"
        >
          <Stack spacing={3}>
            <Text fontSize="lg" fontWeight="semibold">
              Select an organization
            </Text>
            <Text color="gray.600">
              Choose an org to continue. This enables org-scoped JWTs for protected APIs.
            </Text>
            <OrganizationSwitcher />
          </Stack>
        </Box>
      </Center>
    );
  }

  if (provider === AUTH_PROVIDERS.CLERK && hasClientAccess({ orgRole, has })) {
    return <Navigate to="/client/account" replace />;
  }

  if (provider === AUTH_PROVIDERS.CLERK && !hasInternalAccess({ orgRole, has })) {
    return (
      <Center h="100vh" px={6}>
        <Box bg="white" borderWidth="1px" borderRadius="lg" p={6} maxW="560px" w="full" boxShadow="sm">
          <Stack spacing={3}>
            <Text fontSize="lg" fontWeight="semibold">
              Admin access required
            </Text>
            <Text color="gray.600">
              Your active Clerk organization must grant Admin or Member access to open internal dashboards.
            </Text>
            <OrganizationSwitcher />
          </Stack>
        </Box>
      </Center>
    );
  }

  return children;
};

export default ProtectedRoute;
